<template>
    <div>
        <div class="row">
            <div class="col-sm-6 col-md-2">
                <div class="form-group">
                    <button title="Nuevo Registro" id="optionBtnAdd" class="btn btn-success" data-toggle="tooltip" data-placement="right" @click="showModal()">
                        <i class="fa fa-plus"></i>
                        Agregar
                    </button>
                </div>
            </div>
            <div class="col-sm-6 col-md-6 text-right">
                <button v-if="withExportXlsx" class="btn btn-success mr-2"  title="Exportar XLSX" type="button"
                    @click="exportToXlsx">
                    <i aria-hidden="true" class="fas fa-file-excel" style="font-size: 14px"></i>
                    Exportar XLSX
                </button>
                <button v-if="withMassiveImport" class="btn btn-success mr-2"  title="Importación Masiva (Usuario - Centro de Costo)" type="button"
                    @click="showMassiveCostCenterUserUpdate">
                    <i aria-hidden="true" class="fas fa-upload" style="font-size: 14px"></i>
                    Importación (Usuario - Centro de Costo)
                </button>
            </div>
            <div class="col-sm-6 col-md-4">
                <div class="form-group">
                    <form @submit.prevent="search">
                        <div class="input-group">
                            <div class="input-group-prepend">
                            </div>
                            <input class="form-control" v-model="links.search" placeholder="buscar..." type="text" />
                            <div class="input-group-append">
                                <button type="button" @click="search" class="btn btn-outline-secondary" title="buscar..." >
                                    <i class="fa fa-search"></i>
                                </button>
                                <button type="button" class="btn btn-outline-secondary" title="Quitar filtro" @click="reset">
                                    <i class="fa fa-sync-alt"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>         
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                filter: { }
            }
        },
        props: ['links','withExportXlsx','withMassiveImport'],
        methods: {
            index() {
                this.$emit('index');
            },
            reset() {
                this.filter = {};
                this.$router.push({
                    path: this.$route.path
                })
                
            },
            showModal() {
                this.$emit('showModal', true);
            },
            search() {
                this.filter.search = this.links.search;
                 this.$router.push({
                    path: this.$route.path,
                    query: this.filter
                })
            },
            exportToXlsx() {
                this.$emit('exportToXlsx', true);
            },
            showMassiveCostCenterUserUpdate() {
                this.$emit('showMassiveCostCenterUserUpdate', true);
            }
        }
    }

</script>